import { Outlet, useLocation } from 'react-router-dom'
import { Stack, Typography } from '@mui/material'
import { UsersFiltration } from '../../../../components/Users/UsersFiltration'
import { FormBlock } from '../../../../common/FormGenerator'
import { getFormConfig } from '../../../../components/Users/UsersFiltration/settingsConfig'
import { useEffect, useLayoutEffect, useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { PageLayout } from '../../../../components/PageLayout'
import { UsersTabs } from '../../../../components/Users/UsersTabs'
import { useGetUsersStatsQuery } from '../../../../api/users'

const normalizeStringValue = (value: string | null): string => value?.trim() ?? ''

const normalizeAgeValue = (value: string | null): string => {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? String(parsed) : ''
}

export const UsersLayout = () => {
  useLayoutEffect(() => {
    document.title = 'Люди'
  }, [])

  const { search } = useLocation()
  const defaultValues = useMemo(() => {
    const searchParams = new URLSearchParams(search)

    return {
      query: normalizeStringValue(searchParams.get('query')),
      city: normalizeStringValue(searchParams.get('city')),
      status: normalizeStringValue(searchParams.get('status')) || 'all',
      age_from: normalizeAgeValue(searchParams.get('age_from')),
      age_to: normalizeAgeValue(searchParams.get('age_to')),
    }
  }, [search])

  const methods = useForm({ mode: 'all', defaultValues })
  const { reset } = methods

  useEffect(() => {
    reset(defaultValues)
  }, [search, defaultValues, reset])

  const { data: usersStats, isLoading: isStatsLoading, isError: isStatsError } = useGetUsersStatsQuery()

  const completedCount = usersStats?.profiles_completed_count ?? 0
  const incompleteCount = usersStats?.profiles_incomplete_count ?? 0
  const totalCount = completedCount + incompleteCount

  const statsTextSx = { fontSize: 12, lineHeight: 1.4, textTransform: 'none' as const }

  const statsAside = !isStatsLoading && !isStatsError ? (
    <Stack direction="row" spacing={1.5} flexWrap="wrap" alignItems="baseline">
      <Typography component="span" variant="body2" color="text.secondary" sx={statsTextSx}>
        В каталоге: {completedCount}
      </Typography>
      <Typography component="span" variant="body2" color="text.secondary" sx={statsTextSx}>
        Не в каталоге: {incompleteCount}
      </Typography>
      <Typography component="span" variant="body2" color="text.secondary" sx={statsTextSx}>
        Всего: {totalCount}
      </Typography>
    </Stack>
  ) : null

  return (
    <FormProvider {...methods}>
      <PageLayout
        title="Люди"
        titleAside={statsAside}
        mainComponent={<Outlet />}
        sideComponent={<UsersFiltration />}
        searchComponent={<FormBlock formFieldConfig={getFormConfig('query')} />}
        topComponent={<UsersTabs />}
      />
    </FormProvider>
  )
}
